import React, { useContext, useEffect, useState } from "react";

import style from "./CardLogs.module.css";
import axios from "axios";
import { UserContext } from "../../../../Context/UserContextProvider";
const JDate = require('jalali-date');

/**
 * Log types:
 *  0: create
 *  1: Edit
 */

function shouldSkip(title){
    switch(title){
        case "title":
            return false;
        case "image":
            return false;
        case "total_price":
            return false;
        case "metrage_price":
            return false;
        case "rent_price":
            return false;
        case "mortgage_price":
            return false;
        case "slug":
            return false;
        case "construction_date":
            return true;
        case "floor":
            return false;
        case "room_count":
            return false;
        case "description":
            return false;
        case "facilities":
            return false;
        case "construction_year":
            return false;
        case "address":
            return false;
        case "commission":
            return false;
        case "status":
            return false;
        case "units_number":
            return false;
        default:
            return true;
    }
}

function getPersianTitles(title){
    switch(title){
        case "title":
            return "عنوان";
        case "image":
            return "عکس";
        case "total_price":
            return "قیمت کل";
        case "metrage_price":
            return "قیمت هر متر";
        case "rent_price":
            return "اجاره";
        case "mortgage_price":
            return "رهن";
        case "slug":
            return "لینک";
        case "construction_date":
            return "زمان اخرین ویرایش";
        case "floor":
            return "طبقات";
        case "room_count":
            return "تعداد اتاق";
        case "description":
            return "توضیحات";
        case "facilities":
            return "امکانات";
        case "construction_year":
            return "سال ساخت";
        case "address":
            return "آدرس";
        case "commission":
            return "کمیسیون";
        case "status":
            return "وضعیت";
        case "units_number":
            return "تعداد واحد";
        default:
            return title;
    }
}

export default function CardLogs(props){
    let [logsData, setLogsData] = useState([]);
    const { userToken, permissions, consultantData, userData } = useContext(UserContext);
    let [selectedLog, setSelectedLog] = useState(null);

    useEffect(() => {
        axios.get("Estate/EstateLogs?estateId=" + props.id, {
            headers: {
                authorization: "Bearer " + userToken
            }
        }).then((res) => {
            setLogsData(res.data.data);
        });
    }, [props]);

    let isFirstDivider = false;

    if (!props.show){
        return <></>
    }

    if (selectedLog != null){
        var editFields = selectedLog?.oldFields?.split("|");
        editFields?.pop();
        var oldValues = selectedLog?.oldValues?.split("|");
        var newValues = selectedLog?.newValues?.split("|");
        var date = new Date(String(selectedLog?.creationDate));
        var dateString = new JDate(date).format('dddd DD MMMM YYYY');
    }

    return <div className={`${style.background}`} dir="rtl">
        <div className={`${style.main_container}`}>
            <div className={`${style.header}`}>
                <div className={`${style.header_title}`}> {selectedLog == null? "تاریخچه فایل" : selectedLog.title}</div>
                {
                    selectedLog == null? <div className={`${style.header_icon}`}><svg onClick={() => {props.hideFunction(false); setSelectedLog(null)}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style={{height: "15px", width: "15px"}}><path d="M378.4 71.4c8.5-10.1 7.2-25.3-2.9-33.8s-25.3-7.2-33.8 2.9L192 218.7 42.4 40.6C33.9 30.4 18.7 29.1 8.6 37.6S-2.9 61.3 5.6 71.4L160.7 256 5.6 440.6c-8.5 10.2-7.2 25.3 2.9 33.8s25.3 7.2 33.8-2.9L192 293.3 341.6 471.4c8.5 10.1 23.7 11.5 33.8 2.9s11.5-23.7 2.9-33.8L223.3 256l155-184.6z"/></svg></div> : <div className={`${style.header_icon}`}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="" style={{height: "30px"}} onClick={() => {setSelectedLog(null)}}><path d="M54.6 256L144 166.6l0 178.7L54.6 256zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-128 128z"/></svg></div>
                }
            </div>
            {
                selectedLog != null? <>
                    <div className={`${style.item_info}`}>
                        <div className={`${style.item_info_title}`}>
                            تغییرات:
                        </div>
                        {
                            selectedLog.type == 0? <>
                            <div className={`${style.item_changes}`}>
                                <div>فایل ایجاد شد</div>
                            </div>
                            </> : editFields.map((field, index) => {
                                    if (shouldSkip(field)){
                                        return;
                                    }

                                    return <div className={`${style.item_changes}`}>
                                    <p>{getPersianTitles(field)}:</p>
                                    <p>{oldValues[index]}</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{height: "15px", width: "15px"}}><path d="M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"/></svg>
                                    <p>{newValues[index]}</p>
                                </div>
                                })
                        }
                    </div>
                </>
                :
                <>
                <div className={`${style.items}`}>
                {
                    logsData.length == 0?   <div className={`${style.no_item}`}>
                                                داده ای موجود نمیباشد
                                            </div> : <>
                                                {
                                                    logsData.map((log, index) => {
                                                        let date = new Date(String(log.creationDate));
                                                        let dateString = new JDate(date).format('dddd DD MMMM YYYY');
                                                        let timeString = (date.getHours() < 10? "0" + date.getHours() : date.getHours()) + ":" + (date.getMinutes() < 10? "0" + date.getMinutes() : date.getMinutes()) + ":" + (date.getSeconds() < 10? "0" + date.getSeconds() : date.getSeconds());
                                                        let title = log.title;
                                                        isFirstDivider = !isFirstDivider;
                                                        if (index + 1 >= logsData.length){
                                                            return  <div className={`${style.item}`} onClick={() => setSelectedLog(log)}>
                                                                        <div className={`${style.item_counter}`}>
                                                                            {index + 1}
                                                                        </div>
                                                                        <div className={`${style.item_content}`}>
                                                                            <div className={`${style.item_content_title}`}>
                                                                                {title}
                                                                            </div>
                                                                            <div className={`${style.item_content_time}`}>
                                                                                <div>{dateString}</div>
                                                                                <div>.</div>
                                                                                <div>{timeString}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                        }else{
                                                            return <>
                                                                    <div className={`${style.item}`} onClick={() => setSelectedLog(log)}>
                                                                        <div className={`${style.item_counter}`}>
                                                                            {index + 1}
                                                                        </div>
                                                                        <div className={`${style.item_content}`}>
                                                                            <div className={`${style.item_content_title}`}>
                                                                                {title}
                                                                            </div>
                                                                            <div className={`${style.item_content_time}`}>
                                                                                <div>{dateString}</div>
                                                                                <div>.</div>
                                                                                <div>{timeString}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className={`${style.item_seprator}`}>
                                                                        .
                                                                    </div>
                                                            </>
                                                        }
                                                    })
                                                }
                                            </>
                }
                
                
            </div>
                </>
            }
            
            {/*<div className={`${style.items}`}>
                {
                    logsData.length == 0?   <div className={`${style.no_item}`}>
                                                داده ای موجود نمیباشد
                                            </div> : <>
                                                {
                                                    logsData.map((log, index) => {
                                                        let date = new Date(String(log.creationDate));
                                                        let dateString = new JDate(date).format('dddd DD MMMM YYYY');
                                                        let title = log.title;
                                                        isFirstDivider = !isFirstDivider;
                                                        if (index + 1 >= logsData.length){
                                                            return  <div className={`${style.item}`}>
                                                                        <div className={`${style.item_date}`}>
                                                                            <div className={`${style.item_date_text}`}>
                                                                                {dateString}
                                                                            </div>
                                                                        </div>
                                                                        <div className={`${style.item_title}`}>
                                                                            {title}
                                                                        </div>
                                                                    </div>
                                                        }else{
                                                            return <>
                                                                    <div className={`${style.item}`}>
                                                                        <div className={`${style.item_date}`}>
                                                                            <div className={`${style.item_date_text}`}>
                                                                                {dateString}
                                                                            </div>
                                                                        </div>
                                                                        <div className={`${style.item_title}`}>
                                                                            {title}
                                                                        </div>
                                                                    </div>
                                                                    <div className={`${isFirstDivider? style.item_devider : style.item_devider2}`}>
                                                                        .
                                                                    </div>
                                                            </>
                                                        }
                                                    })
                                                }
                                            </>
                }
                
                
            </div>*/}
        </div>
    </div>
}